<template>
  <div class="d-flex h-100 padding">
    <div class="d-flex flex h-100 block m-0">
      <div class="d-flex flex" id="content-body">
        <div class="d-flex flex-column flex" id="mail-list" data-plugin="mail">
          <div class="p-3 b-b">
            <div class="toolbar ">
              <form class="flex">
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm search" placeholder="Suche" v-debounce:300ms="onSearch">
                  <span class="input-group-append">
                  <button class="btn btn-white no-shadow btn-sm i-con-h-a" type="button">
                    <i class="i-con i-con-search text-muted"></i>
                  </button>
                  </span>
                </div>
              </form>
              <button data-toggle="modal" data-target="#content-aside" data-modal class="btn btn-sm btn-white d-md-none i-con-h-a">
                <i class="i-con i-con-nav text-muted"><i></i></i>
              </button>
            </div>
          </div>

          <div class="scroll-y p-3 h-100">
            <div v-if="sliderLoading == true" class="h-100 d-flex justify-content-center align-items-center">
              <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
            </div>
  
            <template v-else class="d-flex">
              <div class="d-flex">
                <div class="col-6 text-center font-weight-bolder bg-success p-3">{{ $t('message.Slider.database') }}</div>
                <div class="col-6 text-center font-weight-bolder bg-info p-3">{{ $t('message.Slider.slider') }}</div>
              </div>
              <div class="d-flex">
                <div class="col-6">
                  <b-table striped hover :items="filteredBooks" :fields="list_fields">
                    <template slot="title" slot-scope="data">
                      <span class="title-column">{{data.value}}</span>
                    </template>

                    <template slot="actions" slot-scope="data">
                      <div class="action-button-container d-flex">

                        <button class="btn btn-sm btn-white i-con-h-a mr-2 bg-success"
                            data-toggle="tooltip"
                            v-b-tooltip.hover
                            title="Add"
                            @click="move(data.item)"
                        >
                          <i class="i-con i-con-arrow-right text-white"><i></i></i>
                        </button>
                      </div>
                    </template>
                  </b-table>
                </div>
                <div class="col-6">
                  <b-table striped hover :items="sliderBooks" :fields="list_fields">
                    <template slot="title" slot-scope="data">
                      <span class="title-column">{{data.value}}</span>
                    </template>

                    <template slot="actions" slot-scope="data">
                      <div class="action-button-container d-flex">

                        <button class="btn btn-sm btn-white i-con-h-a mr-2 bg-danger"
                            data-toggle="tooltip"
                            v-b-tooltip.hover
                            title="Remove"
                            @click="remove(data.item.id)">
                          <i class="i-con i-con-trash text-white"><i></i></i>
                        </button>
                      </div>
                    </template>
                  </b-table>
                </div>
                
              </div>
            </template>        

          </div>
          <div class="p-3 b-t mt-auto">
            <div class="d-flex align-items-center">
              <div class="flex d-flex flex-row">
                <a href="#" class="btn btn-xs white no-border pager-prev hide">
                  <i class="fa fa-angle-left"></i>
                </a>
                <div class="pagination pagination-xs">
                </div>
                <a href="#" class="btn btn-xs white no-border pager-next hide">
                  <i class="fa fa-angle-right"></i>
                </a>
              </div>
              <div>
                <button class="btn btn-sm btn-white i-con-h-a mr-2 bg-danger" :disabled="!commit" @click="commitChanges">{{ $t('message.Slider.commit') }}</button>
              </div>
              <div>
                <span class="text-muted">{{ $t('message.total') }}:</span>
                <span id="count"> {{ filteredBooks.length }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CommaSeparatedSpan from '@/components/CommaSeparatedSpan/CommaSeparatedSpan';
  import {SLIDER_REQUEST, SLIDER_COMMIT} from '@/store/actions/slider';

  export default {
    name: "Slider",

    components: {
      CommaSeparatedSpan
    },

    data() {
      return {
        showData: false,
        searchValue: null,
        list_fields: [
          'id',
          {
            key: 'title',
            label: 'Buchtitel',
            sortable: true
          },
          'actions'
        ],
        sliderBooks: [],
        commit: false,
      }
    },

    mounted() {
      this.$store.dispatch(SLIDER_REQUEST)
        .then(books => {
          this.sliderBooks = JSON.parse(JSON.stringify(books))
        })
    },

    computed: {
      filteredBooks() {
        if (this.searchValue && this.searchValue.length > 2) {
          const s = this.searchValue.toLowerCase();
          return this.books.filter(x => {
            if (x.title.toLowerCase().indexOf(s) !== -1) {
              return true;
            }

            if (x.publisher && x.publisher.name && x.publisher.name.toLowerCase().indexOf(s) !== -1) {
              return true;
            }

            if (this.catIdsFilter && x.category_ids.indexOf(this.catIdsFilter) !== -1) {
              return true;
            }

            return false;
          });
        } else {
          if (this.catIdsFilter) {
            return this.books.filter(x => {
              if (this.catIdsFilter && x.category_ids.indexOf(this.catIdsFilter) !== -1) {
                return true;
              }

              return false;
            });
          }

          return this.books;
        }
      },
    },

    methods: {
      commitChanges() {
        this.$swal({
          title: this.$t("message.Slider.commitChanges"),
          html: this.$t("message.Slider.commitChangesInfo"),
          type: 'info',
          confirmButtonText: this.$t("message.Slider.commit"),
          showCancelButton: true,
        })
            .then(value => {
              if(value.value != undefined) {
                this.$store.dispatch(SLIDER_COMMIT, this.sliderBooks)
                    .then(() => {
                      this.commit = false;
                      this.$swal({
                        title: this.$t("message.success"),
                        text: this.$t("message.Slider.successfullySaved"),
                        type: 'success',
                        confirmButtonText: 'OK'
                      })
                    })
                    .catch(err => {
                      alert('error')
                      console.log(err)
                    })
              }
            });
      },

      onSearch(value) {
        this.searchValue = value;
      },

      move(book) {
        let index = this.sliderBooks.findIndex(elem => elem.id == book.id)

        if (index === -1) {
          this.commit = true;
          this.sliderBooks.push(book)
        }
      },

      remove(bookId) {
        let index = this.sliderBooks.findIndex(elem => elem.id == bookId)

        if (index !== -1) {
          this.commit = true;
          this.sliderBooks.splice(index, 1);
        }
      }
    }
  }
</script>

<style scoped>
  .title-column {
    font-weight: bold;
  }

  .badge-circle.active{
    background: red;
  }
</style>
